import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import isBetween from "dayjs/plugin/isBetween";

dayjs.extend(customParseFormat);
dayjs.extend(isBetween);

export const dateIsBetween = (
    date: string,
    dateFrom: string,
    dateTo: string,
    format: string = 'DD-MM-YYYY',
) => {
    const parsedDate = dayjs(date, format, true);
    const parsedDateFrom = dayjs(dateFrom, format, true);
    const parsedDateTo = dayjs(dateTo, format, true);

    return parsedDate.isBetween(parsedDateFrom, parsedDateTo, 'day', '[]');
};